import React, { useState, useEffect } from "react";
import m from "moment";
import {
  FaCalendarCheck,
  FaClock,
  FaCheckCircle,
  FaEdit,
  FaTrashAlt,
} from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MDSpinner from "react-md-spinner";
import axios from "axios";
import myConfig from "../../../configs/config";
import { useHistory, useParams } from "react-router-dom";

function TableMaintenance({ listMaintenances, t }) {
  // Estado para armazenar o termo de busca
  const [searchTerm, setSearchTerm] = useState("");
  // Estado para armazenar os filtros de status
  const [statusFilters, setStatusFilters] = useState({
    scheduled: true,
    pending: true,
    completed: false,
  });
  // Estado para armazenar a lista de manutenções filtradas
  const [filteredMaintenances, setFilteredMaintenances] = useState([]);
  // Estado para controlar o carregamento
  const [loading, setLoading] = useState(false);
  // Estado para armazenar as manutenções selecionadas
  const [selectedMaintenances, setSelectedMaintenances] = useState([]);
  // Hook de navegação
  const history = useHistory();
  const { farm_id, machine_id } = useParams();

  // Efeito para filtrar as manutenções sempre que os filtros mudarem
  useEffect(() => {
    setLoading(true);

    // Filtra as manutenções com base no termo de busca e nos filtros de status
    const filtered = listMaintenances.filter((item) => {
      // Filtra por nome
      const nameMatch = item.name
        .toLowerCase()
        .includes(searchTerm.toLowerCase());

      // Filtra por status
      const statusMatch = statusFilters[item.status] || false;

      return nameMatch && statusMatch;
    });

    setFilteredMaintenances(filtered);
    setLoading(false);
  }, [searchTerm, statusFilters, listMaintenances]);

  // Função para alterar os filtros de status
  const handleStatusFilterChange = (status) => {
    setStatusFilters((prev) => ({
      ...prev,
      [status]: !prev[status],
    }));
  };

  // Função para exibir mensagem de sucesso
  const toastSuccess = (message) => {
    toast.success(message, {
      position: "bottom-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  // Função para exibir mensagem de erro
  const toastError = (message) => {
    toast.error(message, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  // Função para lidar com o clique no botão de editar
  const handleEditClick = (item) => {
    // Navega para a página de edição com o ID da manutenção
    history.push(
      `/${farm_id}/equipment/machine/${machine_id}/appointments/edit/${item.id}`
    );
  };

  // Função para lidar com o clique no nome da tarefa (detalhes)
  const handleDetailClick = (item) => {
    // Navega para a página de detalhes com o ID da manutenção
    history.push(
      `/${farm_id}/equipment/machine/${machine_id}/appointments/detail/${item.id}`
    );
  };

  const handleCompleteClick = (item) => {
    try {
      axios.post(
        `${myConfig.API_URL}/scheduled_maintenance/${item.id}/complete/`
      );
      toastSuccess(`Manutenção concluída: ${item.name}`);
    } catch (error) {
      toastError(`Erro ao excluir a manutenção: ${error.message}`);
    }
  };

  const handleDeleteClick = (item) => {
    if (!window.confirm(`Deseja excluir a manutenção ${item.name}?`)) {
      return;
    }
    try {
      axios.delete(`${myConfig.API_URL}/scheduled_maintenance/${item.id}`);
      toastSuccess(`Manutenção excluída: ${item.name}`);
      setFilteredMaintenances((prev) =>
        prev.filter((maintenance) => maintenance.id !== item.id)
      );
    } catch (error) {
      toastError(`Erro ao excluir a manutenção: ${error.message}`);
    }
  };

  // Componente de spinner para carregamento
  function Spinner() {
    return (
      <div style={{ marginTop: "50px", marginLeft: "50%", minHeight: "200px" }}>
        <MDSpinner />
      </div>
    );
  }

  // Função para selecionar todas as manutenções
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      // Seleciona todas as manutenções
      const allIds = filteredMaintenances.map((item) => item.id);
      setSelectedMaintenances(allIds);
    } else {
      // Limpa a seleção
      setSelectedMaintenances([]);
    }
  };

  // Função para selecionar uma manutenção específica
  const handleSelectMaintenance = (e, maintenanceId) => {
    if (e.target.checked) {
      setSelectedMaintenances([...selectedMaintenances, maintenanceId]);
    } else {
      setSelectedMaintenances(
        selectedMaintenances.filter((id) => id !== maintenanceId)
      );
    }
  };

  return (
    <div className="maintenance-list-container">
      <div className="row mb-4">
        <div className="col-lg-6 col-md-12 mb-3">
          <div className="form-group">
            <label htmlFor="searchTask" className="font-weight-bold mb-2">
              {t("Buscar tarefa")}
            </label>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <i className="fa fa-search"></i>
                </span>
              </div>
              <input
                type="text"
                className="form-control"
                id="searchTask"
                placeholder={t("Digite o nome da tarefa")}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-12 mb-3">
          <label className="font-weight-bold mb-2">
            {t("Filtrar por status")}
          </label>
          <div className="status-filter-container d-flex flex-wrap">
            <span
              className={`filter-text ${
                statusFilters.scheduled ? "active-filter scheduled" : ""
              }`}
              onClick={() => handleStatusFilterChange("scheduled")}
            >
              <FaCalendarCheck size={14} style={{ marginRight: "4px" }} />
              {t("Agendada")}
            </span>
            <span
              className={`filter-text ${
                statusFilters.pending ? "active-filter pending" : ""
              }`}
              onClick={() => handleStatusFilterChange("pending")}
            >
              <FaClock size={14} style={{ marginRight: "4px" }} />
              {t("Pendente")}
            </span>
            <span
              className={`filter-text ${
                statusFilters.completed ? "active-filter completed" : ""
              }`}
              onClick={() => handleStatusFilterChange("completed")}
            >
              <FaCheckCircle size={14} style={{ marginRight: "4px" }} />
              {t("Concluída")}
            </span>
          </div>
        </div>
      </div>
      <div className="x_content">
        {loading ? (
          <Spinner />
        ) : (
          <>
            {/* Visualização em desktop */}
            <div className="table-responsive d-none d-lg-block">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        onChange={handleSelectAll}
                        checked={
                          selectedMaintenances.length ===
                            filteredMaintenances.length &&
                          filteredMaintenances.length > 0
                        }
                      />
                    </th>
                    <th>{t("Tarefa")}</th>
                    <th>{t("Status")}</th>
                    <th>{t("Próxima manutenção")}</th>
                    <th>{t("Ações")}</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredMaintenances.length > 0 ? (
                    filteredMaintenances.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedMaintenances.includes(item.id)}
                            onChange={(e) =>
                              handleSelectMaintenance(e, item.id)
                            }
                          />
                        </td>
                        <td>
                          <span
                            className="task-name-link"
                            onClick={() => handleDetailClick(item)}
                            style={{ cursor: "pointer", color: "#007bff" }}
                            title={t("Ver detalhes")}
                          >
                            {item.name}
                          </span>
                        </td>
                        <td>
                          <span
                            className={`badge badge-${
                              item.status === "scheduled"
                                ? "info"
                                : item.status === "pending"
                                ? "warning"
                                : "success"
                            }`}
                          >
                            {t(item.status_display)}
                          </span>
                        </td>
                        <td>
                          {item.scheduled_date
                            ? m(item.scheduled_date).format("DD/MM/YYYY")
                            : item.meter_threshold}
                        </td>
                        <td>
                          <div className="btn-group" role="group">
                            {item.status === "scheduled" && (
                              <button
                                className="btn btn-sm btn-primary"
                                onClick={() => handleEditClick(item)}
                                title={t("Editar")}
                              >
                                <FaEdit />
                              </button>
                            )}
                            {item.status === "pending" && (
                              <button
                                className="btn btn-sm btn-success"
                                onClick={() => handleCompleteClick(item)}
                                title={t("Concluir")}
                              >
                                <FaCheckCircle />
                              </button>
                            )}
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => handleDeleteClick(item)}
                              title={t("Excluir")}
                            >
                              <FaTrashAlt />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        {t("Nenhuma manutenção encontrada")}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>{" "}
            {/* Visualização em mobile */}
            <div className="d-block d-lg-none">
              {filteredMaintenances.length > 0 ? (
                <div className="mobile-maintenance-list">
                  {filteredMaintenances.map((item, index) => (
                    <div key={index} className="mobile-maintenance-card">
                      <div className="mobile-card-header">
                        <div className="d-flex align-items-center">
                          <input
                            type="checkbox"
                            checked={selectedMaintenances.includes(item.id)}
                            onChange={(e) =>
                              handleSelectMaintenance(e, item.id)
                            }
                            className="me-2"
                          />
                          <h6
                            className="card-title mb-0 task-name-link"
                            onClick={() => handleDetailClick(item)}
                            style={{ cursor: "pointer", color: "#007bff" }}
                            title={t("Ver detalhes")}
                          >
                            {item.name}
                          </h6>
                        </div>
                        <span
                          className={`badge badge-${
                            item.status === "scheduled"
                              ? "info"
                              : item.status === "pending"
                              ? "warning"
                              : "success"
                          }`}
                        >
                          {t(item.status_display)}
                        </span>
                      </div>
                      <div className="mobile-card-body">
                        <div className="maintenance-info">
                          <small className="text-muted">
                            {t("Próxima manutenção")}:
                          </small>
                          <span className="maintenance-date">
                            {item.scheduled_date
                              ? m(item.scheduled_date).format("DD/MM/YYYY")
                              : item.meter_threshold}
                          </span>
                        </div>
                        <div className="mobile-actions">
                          {item.status === "scheduled" && (
                            <button
                              className="btn btn-sm btn-primary me-2"
                              onClick={() => handleEditClick(item)}
                              title={t("Editar")}
                            >
                              <FaEdit /> {t("Editar")}
                            </button>
                          )}
                          {item.status === "pending" && (
                            <button
                              className="btn btn-sm btn-success me-2"
                              onClick={() => handleCompleteClick(item)}
                              title={t("Concluir")}
                            >
                              <FaCheckCircle /> {t("Concluir")}
                            </button>
                          )}
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => handleDeleteClick(item)}
                            title={t("Excluir")}
                          >
                            <FaTrashAlt /> {t("Excluir")}
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-4">
                  <p className="text-muted">
                    {t("Nenhuma manutenção encontrada")}
                  </p>
                </div>
              )}
            </div>
          </>
        )}
      </div>
      {/* Área de ações em lote para as manutenções selecionadas */}
      {selectedMaintenances.length > 0 && (
        <div className="batch-actions mt-3 mb-3 p-3 bg-light rounded">
          <div className="d-flex justify-content-between align-items-center">
            <span>
              <strong>{selectedMaintenances.length}</strong>{" "}
              {t("manutenções selecionadas")}
            </span>
            <div className="btn-group">
              <button
                className="btn btn-success"
                onClick={() => {
                  toastSuccess(
                    `${selectedMaintenances.length} manutenções concluídas`
                  );
                  setSelectedMaintenances([]);
                }}
              >
                <i className="fa fa-check-circle"></i>{" "}
                {t("Concluir Selecionadas")}
              </button>
              <button
                className="btn btn-danger"
                onClick={() => {
                  if (
                    window.confirm(
                      `Deseja excluir ${selectedMaintenances.length} manutenções?`
                    )
                  ) {
                    toastSuccess(
                      `${selectedMaintenances.length} manutenções excluídas`
                    );
                    setSelectedMaintenances([]);
                  }
                }}
              >
                <i className="fa fa-trash"></i> {t("Excluir Selecionadas")}
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />{" "}
      <style jsx="true">
        {`
          /* Forçar responsividade */
          @media (max-width: 991.98px) {
            .d-none.d-lg-block {
              display: none !important;
            }
            .d-block.d-lg-none {
              display: block !important;
            }
          }

          @media (min-width: 992px) {
            .d-none.d-lg-block {
              display: block !important;
            }
            .d-block.d-lg-none {
              display: none !important;
            }
          }

          .task-name-link {
            text-decoration: none;
            transition: all 0.2s ease;
          }

          .task-name-link:hover {
            color: #0056b3 !important;
            text-decoration: underline;
            transform: scale(1.02);
          }

          .filter-text {
            padding: 6px 12px;
            margin-right: 15px;
            margin-bottom: 8px;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            border-radius: 20px;
            transition: all 0.2s ease;
            font-size: 0.9rem;
            color: #6c757d;
          }

          .filter-text:hover {
            transform: translateY(-2px);
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
          }

          .active-filter {
            font-weight: 600;
          }

          .active-filter.scheduled {
            color: #17a2b8;
            border-bottom: 2px solid #17a2b8;
          }

          .active-filter.pending {
            color: #ffc107;
            border-bottom: 2px solid #ffc107;
          }

          .active-filter.completed {
            color: #28a745;
            border-bottom: 2px solid #28a745;
          }

          .status-filter-container {
            width: 100%;
            display: flex;
            justify-content: flex-start;
          }

          .badge {
            padding: 6px 8px;
            font-size: 0.9em;
          }

          .badge-info {
            background-color: #17a2b8;
          }

          .badge-warning {
            background-color: #ffc107;
            color: #212529;
          }

          .badge-success {
            background-color: #28a745;
          }

          .btn-group .btn {
            margin-right: 5px;
          }

          .batch-actions {
            border: 1px solid #ddd;
          }

          /* Estilos para mobile */
          .mobile-maintenance-list {
            display: flex;
            flex-direction: column;
            gap: 12px;
          }

          .mobile-maintenance-card {
            background: #fff;
            border: 1px solid #e9ecef;
            border-radius: 8px;
            padding: 16px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
            transition: all 0.2s ease;
          }

          .mobile-maintenance-card:hover {
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
            transform: translateY(-1px);
          }

          .mobile-card-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 12px;
            padding-bottom: 8px;
            border-bottom: 1px solid #f1f3f4;
          }

          .mobile-card-header h6 {
            margin: 0;
            font-size: 1rem;
            font-weight: 600;
            color: #495057;
            flex: 1;
            margin-left: 8px;
          }

          .mobile-card-body {
            display: flex;
            flex-direction: column;
            gap: 12px;
          }

          .maintenance-info {
            display: flex;
            flex-direction: column;
            gap: 4px;
          }

          .maintenance-info small {
            font-size: 0.75rem;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          .maintenance-date {
            font-weight: 500;
            color: #495057;
            font-size: 0.9rem;
          }

          .mobile-actions {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            justify-content: flex-end;
          }

          .mobile-actions .btn {
            display: flex;
            align-items: center;
            gap: 4px;
            font-size: 0.8rem;
            padding: 6px 12px;
          }

          /* Responsividade adicional */
          @media (max-width: 576px) {
            .filter-text {
              margin-right: 8px;
              padding: 4px 8px;
              font-size: 0.8rem;
            }

            .status-filter-container {
              flex-wrap: wrap;
              gap: 4px;
            }

            .mobile-maintenance-card {
              padding: 12px;
            }

            .mobile-card-header h6 {
              font-size: 0.9rem;
            }

            .mobile-actions {
              justify-content: center;
            }

            .mobile-actions .btn {
              font-size: 0.75rem;
              padding: 4px 8px;
            }

            .badge {
              font-size: 0.7rem;
              padding: 4px 6px;
            }
          } /* Ajustes para ações em lote em mobile */
          @media (max-width: 991.98px) {
            .batch-actions .d-flex {
              flex-direction: column;
              gap: 12px;
            }

            .batch-actions .btn-group {
              display: flex;
              flex-direction: column;
              gap: 8px;
            }

            .batch-actions .btn-group .btn {
              margin-right: 0;
              width: 100%;
            }
          }
        `}
      </style>
    </div>
  );
}

export default TableMaintenance;
